import { render, staticRenderFns } from "./ReAssignList.vue?vue&type=template&id=f455012c"
import script from "./ReAssignList.vue?vue&type=script&lang=js"
export * from "./ReAssignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports